import type { ElementType, ReactNode } from 'react'
import React from 'react'
interface ContainerProps {
  children: ReactNode
  /** Renders a different element where the landmark matters, e.g. `nav`. */
  as?: ElementType
  className?: string
}

/**
 * The single horizontal rhythm for the site: 1280px of content with padding
 * that steps 20 → 28 → 32px, so nothing ever hugs the viewport edge.
 */
export function Container({ children, as: Tag = 'div', className = '' }: ContainerProps) {
  return (
    <Tag className={`mx-auto w-full max-w-page px-5 sm:px-7 lg:px-8 ${className}`}>{children}</Tag>
  )
}
